import React, { useEffect, useState, useRef, useContext, FC, JSX } from "react";

//import { ActionMeta, SingleValue, MultiValue } from "react-select"

import HeadStraightOn from '../images/head-directions/straight-on.png';
import HeadProfile from '../images/head-directions/right-profile.png';
import HeadSlightAngle from '../images/head-directions/right-10.png';
import HeadThreeQuarters from '../images/head-directions/right-45.png';
import HeadAlmostProfile from '../images/head-directions/right-80.png';
import HeadUp from '../images/head-directions/up.png';
import HeadDown from '../images/head-directions/down.png';
import HeadUpRight from '../images/head-directions/up-right.png';
import HeadDownRight from '../images/head-directions/down-right.png';
import { useRouter } from 'next/router';
import { Grid, Pagination, Input, Text, ComboboxItem} from '@mantine/core';
import Image from 'next/image'
import { useAuth as useClerkAuth } from '@clerk/nextjs'

import {
  MultiSelect,
  MultiSelectProps,
} from '@mantine/core';

import { DatePickerInput } from '@mantine/dates';

type MultiValue<Option> = readonly Option[];

import { Select } from '@mantine/core';

import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

//import Masonry from 'masonry-layout';

import './PublicSearch.module.scss';

import { Modal, Button, Group } from '@mantine/core';

import styles from './PublicSearch.module.scss'

import { Video, VideoSearchResult, SearchJson, Photo, RusAuthProps, RusContextProps, SubscriberLevel, ImageSearchResult } from '../lib/definitions';
import { useRawUmberContext } from "../lib/rawumberprovider";
import useAuth from "../lib/useAuth";
import { logEvent } from "../lib/logger";
import Link from "next/link";
import { VideoElement, VideoList } from "./Video";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/sharp-solid-svg-icons";
import { AspectBox } from "./AspectBox";
import { useHistoryState } from "../lib/useHistoryState";
import { getClerkHeader } from "../lib/common";


const ajaxUrl = process.env.NEXT_PUBLIC_ELTON_ROUTE;

type OptionType = {
    label: string;
    value: string;
    metadata?: any;
};

interface ISearchContext
{
    freeText ?: string;
    setFreeText: React.Dispatch<any>;
    advancedSearch?: boolean;
    //setAdvancedSearch: React.Dispatch<any>;
    setAdvancedSearch: (x:boolean) => void;
    categoryType?: OptionType | undefined;
    setCategoryType: React.Dispatch<OptionType | undefined>;
    materials?: MultiValue<OptionType> | undefined;
    setMaterials: React.Dispatch<MultiValue<OptionType> | undefined>;
    videoTypes?: MultiValue<OptionType> | undefined;
    setVideoTypes: React.Dispatch<MultiValue<OptionType> | undefined>;
    modelId?: OptionType | null;
    setModelId: React.Dispatch<OptionType | undefined>;
    modelList?: MultiValue<OptionType>;
    tutorList?: MultiValue<OptionType>;
    headDirections?: MultiValue<OptionType> | undefined;
    setHeadDirections: React.Dispatch<MultiValue<OptionType> | undefined>;
    skinTones?: MultiValue<OptionType> | undefined;
    setSkinTones: React.Dispatch<any>;
    ages?: MultiValue<OptionType> | undefined;
    setAges: React.Dispatch<MultiValue<OptionType>>;
    figurePoseTypes?: MultiValue<OptionType> | undefined;
    setFigurePoseTypes: React.Dispatch<MultiValue<OptionType>>;
    genders?: MultiValue<OptionType> | undefined;
    setGenders: React.Dispatch<MultiValue<OptionType>>;
    bodyTypes?: MultiValue<OptionType> | undefined;
    setBodyTypes: React.Dispatch<MultiValue<OptionType>>;
    hairLengths?: MultiValue<OptionType> | undefined;
    setHairLengths: React.Dispatch<MultiValue<OptionType>>;
    tutorId?: OptionType | undefined;
    setTutorId: React.Dispatch<OptionType | undefined>;
    dateFrom?: string | null;
    setDateFrom: React.Dispatch<string | null>;
    dateTo?: string | null;
    setDateTo: React.Dispatch<string | null>;
    poseType?: OptionType | null;
    setPoseType: React.Dispatch<OptionType|null|undefined>;
    nudity?: boolean | null;
    setNudity: React.Dispatch<boolean|null>;
    colouredLighting?: boolean | null;
    setColouredLighting: React.Dispatch<boolean|null>;
    colouredBackground?: boolean | null;
    setColouredBackground: React.Dispatch<boolean|null>;
    expressive?: boolean | null;
    setExpressive: React.Dispatch<boolean|null>;
    drapery?: boolean | null;
    setDrapery: React.Dispatch<boolean|null>;
    eyes?: boolean | null;
    setEyes: React.Dispatch<boolean|null>;
    ears?: boolean | null;
    setEars: React.Dispatch<boolean|null>;
    mouth?: boolean | null;
    setMouth: React.Dispatch<boolean|null>;
    nose?: boolean | null;
    setNose: React.Dispatch<boolean|null>;
    torso?: boolean | null;
    setTorso: React.Dispatch<boolean|null>;
    legs?: boolean | null;
    setLegs: React.Dispatch<boolean|null>;
    back?: boolean | null;
    setBack: React.Dispatch<boolean|null>;
    arms?: boolean | null;
    setArms: React.Dispatch<any>;
    fancyDress?: boolean | null;
    setFancyDress: React.Dispatch<boolean|null>;
    facialHair?: boolean | null;
    setFacialHair: React.Dispatch<boolean|null>;
    dramaticLighting?: boolean | null;
    setDramaticLighting: React.Dispatch<boolean|null>;
    quickPoses?: boolean | null;
    setQuickPoses: React.Dispatch<boolean|null>;
    pageSize: number,
    totalCount?: number,
    searchType?: string,
    jwtToken?: string,
    pageCount: number,
    pageNumber?: number,
    setOffset: React.Dispatch<number>,
    searchData?: SearchJson,
    setSearchData: React.Dispatch<SearchJson>,
    setImageList: React.Dispatch<Array<Photo>>,
    setPageNumber: React.Dispatch<number>,
    setVideoList: React.Dispatch<Array<Video>>,
    working: boolean,
    setWorking: React.Dispatch<boolean>,
    videoList: Array<Video> | null,
    //tutorMap: Map<number, string> | null,
    searchImages: () => Promise<void>,
    imageList: Array<Photo>,
    canAccess: boolean,
    visiblePhoto: Photo | null,
    setVisiblePhoto: React.Dispatch<Photo>,
    showLightBox: boolean,
    setShowLightBox: React.Dispatch<boolean>,
    dateProcessed: string,
    setDateProcessed: React.Dispatch<string>

};

const defaultState : ISearchContext  = 
{
    setFreeText: () => null,
    setCategoryType: () => null,
    setMaterials: () => null,
    setAdvancedSearch: () => null,
    setVideoTypes: () => null,
    setHeadDirections: () => null,
    setAges: () => null,
    setFigurePoseTypes: () => null,
    setGenders: () => null,
    setBodyTypes: () => null,
    setHairLengths: () => null,
    setTutorId: () => null,
    setDateFrom: () => null,
    setDateTo: () => null,
    setPoseType: () => null,
    setNudity: () => null,
    setColouredLighting: () => null,
    setColouredBackground: () => null,
    setExpressive: () => null,
    setDrapery: () => null,
    setEyes: () => null,
    setEars: () => null,
    setMouth: () => null,
    setSkinTones: () => null,
    setNose: () => null,
    setTorso: () => null,
    setLegs: () => null,
    setArms: () => null,
    setBack: () => null,
    setFancyDress: () => null,
    setFacialHair: () => null,
    setDramaticLighting: () => null,
    setModelId: () => null,
    setQuickPoses: () => null,
    setImageList: () => null,
    setPageNumber: () => null,
    setVideoList: () => null,
    setWorking: () => null,
    pageSize:25,
    pageCount:0,
    setOffset: () => null,
    videoList: [],
    //tutorMap: null,
    searchImages: async () => { },
    working: false,
    imageList: [],
    canAccess: false,
    visiblePhoto: null,
    setVisiblePhoto: () => null,
    setShowLightBox: () => null,
    showLightBox: false,
    setSearchData: () => null,
    dateProcessed:"",
    setDateProcessed: () => null

}

const SearchContext = React.createContext<ISearchContext>(defaultState);

function GetValues(values: MultiValue<OptionType> | undefined): string[] | null {

    if (values === undefined) {
        return null;
    }

    let b = values.map(x => x.value);
    return b;
}

interface TriStateProps {
    value?: boolean | null | undefined,
    label: string,
    onChanged: (value: boolean|null) => void
}

function TriState(props: TriStateProps) {

    const checkRef = useRef<HTMLInputElement>(null);
    const [state, setState] = useState<boolean | null | undefined>(props.value);

    function TriClicked (event: React.MouseEvent<HTMLElement>)
    {
        let newValue: boolean | null;

        if (state == null) {
            newValue = true;
        }
        else if (state == true) {
            newValue = false;
        }
        else
        {
            newValue = null;
        }

        setState(newValue);

        if (props.onChanged) {
            props.onChanged(newValue);
        }   
       
    }
    useEffect(() => {
        if (state == null) {

            if (checkRef.current != null) {
                checkRef.current.indeterminate = true;
                }
        }
        else {
            if (checkRef.current != null) {
                checkRef.current.indeterminate = false;
            }
        }

    });

 
    return (<><input className="tristate" type="checkbox" onClick={TriClicked} ref={checkRef} readOnly checked={state ?? false}/><label>{props.label}</label></>);

}

export default function PublicSearch(props: RusContextProps & {searchType:string} & {data?: {videos?: Video[], images?: Photo[], count: number, dateProcessed:string, pinnedVideo: Video | null, modelId?: number, category?: string}}) {

    let pageSize = props.searchType == 'image' ? 50 : 25;

    let searchType = props.searchType;

    const [poseType, setPoseType] = useHistoryState<OptionType | undefined | null>(searchType+"_" + "poseType", undefined);
    const [working, setWorking] = useState(false);
    const [imageList, setImageList] = useHistoryState<Array<Photo>>(searchType+"_" + "images",  (props?.data?.images)?props.data.images:[]);
    const [ages, setAges] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "ages", undefined);
    const [headDirections, setHeadDirections] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "headDirections", undefined);
    const [nudity, setNudity] = useHistoryState<boolean | null>(searchType+"_" + "nudity", null);
    const [hairLengths, setHairLengths] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "hairLengths", undefined);
    const [genders, setGenders] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "genders", undefined);
    const [skinTones, setSkinTones] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "skinTones", undefined);
    const [bodyTypes, setBodyTypes] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "bodyTypes", undefined);
    const [figurePoseTypes, setFigurePoseTypes] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "figurePoseTypes", undefined);
    const [expressive, setExpressive] = useHistoryState<boolean | null>(searchType+"_" + "expressive", null);
    const [drapery, setDrapery] = useHistoryState<boolean | null>(searchType+"_" + "drapery", null);
    const [eyes, setEyes] = useHistoryState<boolean | null>(searchType+"_" + "eyes", null);
    const [ears, setEars] = useHistoryState<boolean | null>(searchType+"_" + "ears", null);
    const [mouth, setMouth] = useHistoryState<boolean | null>(searchType+"_" + "mouth", null);
    const [nose, setNose] = useHistoryState<boolean | null>(searchType+"_" + "nose", null);
    const [torso, setTorso] = useHistoryState<boolean | null>(searchType+"_" + "torso", null);
    const [legs, setLegs] = useHistoryState<boolean | null>(searchType+"_" + "legs", null);
    const [arms, setArms] = useHistoryState<boolean | null>(searchType+"_" + "arms", null);
    const [back, setBack] = useHistoryState<boolean | null>(searchType+"_" + "back", null);
    const [fancyDress, setFancyDress] = useHistoryState<boolean | null>(searchType+"_" + "fancyDress", null);
    const [dramaticLighting, setDramaticLighting] = useHistoryState<boolean | null>(searchType+"_" + "dramaticLighting", null);
    const [colouredLighting, setColouredLighting] = useHistoryState<boolean | null>(searchType+"_" + "colouredLighting", null);
    const [colouredBackground, setColouredBackground] = useHistoryState<boolean | null>(searchType+"_" + "colouredBackground", null);
    const [facialHair, setFacialHair] = useHistoryState<boolean | null>(searchType+"_" + "facialHair", null);
    const [modelList, setModelList] = useState<MultiValue<OptionType> | undefined>(undefined);
    const [modelId, setModelId] = useHistoryState<OptionType | undefined | null>(searchType+"_" + "modelId", undefined);
    const [offset, setOffset] = useHistoryState(searchType+"_" + "offset", 0);
    const [totalCount, setTotalCount] = useHistoryState<number>(searchType+"_" + "totalCount", props.data?props.data.count:0);
    const [pageCount, setPageCount] = useHistoryState(searchType+"_" + "pageCount", Math.ceil((props.data?props.data.count:0) / pageSize));
    const [pageNumber, setPageNumber] = useHistoryState<number>(searchType+"_" + "pageNumber", 1);
    //let x: SearchJson = {Count: props.searchType == 'image' ? 50 : 25, Offset:0};

    const [showLightBox, setShowLightBox] = useState(false);

    const [materials, setMaterials] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "materials", undefined);
    const [quickPoses, setQuickPoses] = useHistoryState<boolean | null>(searchType+"_" + "quickposes", null);
    const [videoTypes, setVideoTypes] = useHistoryState<MultiValue<OptionType> | undefined>(searchType+"_" + "videoTypes", undefined);
    const [tutorId, setTutorId] = useHistoryState<OptionType | undefined>(searchType+"_" + "tutorId", undefined);
    const [videoList, setVideoList] = useHistoryState<Array<Video> | null>(searchType+"_" + "videoList", (props.data?.videos)?props.data.videos:null);
    const [pinnedVideo, setPinnedVideo] = useState<Video | null>(props.data?props.data.pinnedVideo:null);

    const [dateFrom, setDateFrom]= useHistoryState<string|null>(searchType+"_" + "dateFrom", null);
    const [dateTo, setDateTo] = useHistoryState<string|null>(searchType+"_" + "dateTo", null);

    const [categoryType, setCategoryType] = useHistoryState<OptionType | undefined>(searchType+"_" + "categoryType", props.searchType == 'image' ? getCategoryOptionType(props.data?.category)  : undefined);

    const [currentPhoto, setCurrentPhoto] = useState<Photo | null>(null);

    const {timeOffset}=useRawUmberContext();

    const {authToken, userInformation}=useAuth();

    let ui = userInformation;

    const [canAccess, setCanAccess] = useHistoryState(searchType+"_canAccess", !!(ui?.subscribed && (ui?.subscriber_level==SubscriberLevel.gold || ui?.subscriber_level==SubscriberLevel.image)));

    //setCategoryType(props.searchType == 'image' ? { value: 'human', label: 'Human' }:null)

    const [advancedSearch, setAdvancedSearch] = useHistoryState(searchType+"_" + "advancedSearch", false);
    const [freeText, setFreeText] = useHistoryState(searchType+"_freeText","");

    const [dateProcessed, setDateProcessed] = useState(props.data?props.data.dateProcessed:(DateTime.now().plus(timeOffset??0).toISO()));

    let r2 = props.tutors?.map<OptionType>(({ id, name }) => (  { label: name, value: '' + id } ) );
    let r3 = new Map(props.tutors?.map(({ id, name }) => [id, name]));
    const [tutorList, setTutorList] = useState<MultiValue<OptionType> | undefined>(r2);
    //const [tutorMap, setTutorMap] = useState<Map<number, string> | null>(r3);


    const [searchData, setSearchData] = useState<SearchJson>({...getSearchData(), Count: props.searchType == 'image' ? 50 : 25, Offset:0} );

    const firstRender = useRef(true);

    const { getToken } = useClerkAuth();


    useEffect(() =>
    {

        if (!firstRender.current)
        {
            searchImages();
        }
        firstRender.current = false;
    }, [categoryType]);
    useEffect(() => {

        async function getModels() {
            const a =  await fetch(ajaxUrl + "/models");
            let result : {id:number, publicName : string} [] = await a.json();
           
            let r2: OptionType[];

            r2 = result.map(({ id, publicName }) => ({ label: publicName, value: '' + id }));
            setModelList(r2);

            if (props.data?.modelId)
            {
                let o = r2.find(x=>(x.value == '' + props.data?.modelId));
                
                if (o)
                {
                    setModelId(o);
                }

            }
        }

        getModels();

        if (props.searchType != 'image') {
            //don't perform an initial search for images
            //do this in getServersideProps
            //searchImages();
        }
    }, []);

    function getSearchData()
    {
            let sd : SearchJson = {
            PoseType: poseType?.value,
            Ages: GetValues(ages),
            Nude: nudity,
            Genders: GetValues(genders),
            SkinTones: GetValues(skinTones),
            FigurePoseTypes: GetValues(figurePoseTypes),
            BodyTypes: GetValues(bodyTypes),
            Expressive: expressive,
            Drapery: drapery,
            Eyes: eyes,
            Ears: ears,
            Mouth: mouth,
            Nose: nose,
            Torso: torso,
            Legs: legs,
            Arms: arms,
            Back: back,
            FacialHair: facialHair,
            FancyDress: fancyDress,
            DramaticLighting: dramaticLighting,
            ColouredBackground: colouredBackground,
            ColouredLighting: colouredLighting,
            HairLengths: GetValues(hairLengths),
            Materials: GetValues(materials),
            VideoTypes: GetValues(videoTypes),
            QuickPoses: quickPoses,
            SubjectType: categoryType?.value,
            DateFrom: dateFrom,
            DateTo: dateTo,
            FreeText: freeText,
            Count: pageSize,
            Offset: 0,
            //JwtToken: props.jwtToken
        };

        if (categoryType != null && props.searchType == 'image') {
            sd.ReferenceType = categoryType.value;
        }

        if (modelId !== null && modelId != undefined && modelId?.value != "") {
            sd.ModelId = parseInt(modelId.value);
        }

        if (tutorId !== null && tutorId != undefined && tutorId?.value != "") {
            sd.TutorId = parseInt(tutorId.value);
        }
        if (headDirections != null) {
            let h = Array.from(headDirections);
            if (h.length != 0) {
                let a = [];

                for (var i = 0; i < h.length; i++) {
                    switch (h[i].value) {
                        case 'SlightAngle':
                            a.push('Right10');
                            a.push('Left10');
                            break;
                        case 'ThreeQuarters':
                            a.push('Right45');
                            a.push('Left45');
                            break;
                        case 'AlmostProfile':
                            a.push('Left80');
                            a.push('Right80');
                            break;
                        case 'Profile':
                            a.push('LeftProfile');
                            a.push('RightProfile');
                            break;
                        case 'UpOneSide':
                            a.push('UpRight');
                            a.push('UpLeft');
                            break;
                        case 'DownOneSide':
                            a.push('DownRight');
                            a.push('DownLeft');
                            break;
                        default:
                            a.push(h[i].value);
                            break;
                    }
                }

                sd.HeadDirections = a;
            }
    }

    return sd;

    }

    async function searchImages() {

            let sd = getSearchData();


        setSearchData(sd);

        setCanAccess(false);

        let ui = userInformation;

        if (ui?.subscribed && (ui?.subscriber_level==SubscriberLevel.gold || ui?.subscriber_level==SubscriberLevel.image))
        {
            setCanAccess(true);
        } 

        let json = encodeURIComponent(JSON.stringify(sd, (_, v) => { if (v != null) return v; }));
        setWorking(true);

        const clerkToken = await getToken();

        let options = { 
            method: 'GET',
            cache: "no-store" as RequestCache,
            headers: {... authToken?{'auth-token': authToken}:{}, ...getClerkHeader(clerkToken)} as HeadersInit
        }

        if (props.searchType == 'image') {
            logEvent('image_search', sd);
            const result: ImageSearchResult = await (await fetch(ajaxUrl + "/imagesearch?json=" + json, options)).json();
            setImageList(result.photos);
            if (result.count !== undefined) {
                setTotalCount(result.count);
                setPageCount(Math.ceil(result.count / pageSize))
            }
        }
        else {
            logEvent('video_search', sd);
            const result: VideoSearchResult = await (await fetch(ajaxUrl + "/videosearch?json=" + json, options)).json();
            setVideoList(result.videos);
            if (result.count !== undefined) {
                setTotalCount(result.count);
                setPageCount(Math.ceil(result.count / pageSize))
            }

        }   

        setPageNumber(1);
        setOffset(0);

        setWorking(false);
    }

    let context: ISearchContext = {
        freeText: freeText,
        setFreeText: setFreeText,
        advancedSearch: advancedSearch,
        setAdvancedSearch: setAdvancedSearch,
        categoryType: categoryType,
        setCategoryType: setCategoryType,
        materials: materials,
        setMaterials: setMaterials,
        videoTypes: videoTypes,
        setVideoTypes: setVideoTypes,
        headDirections: headDirections,
        setHeadDirections: setHeadDirections,
        ages: ages,
        setAges: setAges,
        figurePoseTypes: figurePoseTypes,
        setFigurePoseTypes: setFigurePoseTypes,
        genders: genders,
        setGenders: setGenders,
        bodyTypes: bodyTypes,
        setBodyTypes: setBodyTypes,
        hairLengths: hairLengths,
        setHairLengths: setHairLengths,
        tutorId: tutorId,
        setTutorId: setTutorId,
        dateFrom: dateFrom,
        setDateFrom: setDateFrom,
        dateTo: dateTo,
        setDateTo: setDateTo,
        poseType: poseType,
        setPoseType: setPoseType,
        nudity: nudity,
        setNudity: setNudity,
        colouredLighting: colouredLighting,
        setColouredLighting: setColouredLighting,
        colouredBackground: colouredBackground,
        setColouredBackground: setColouredBackground,
        expressive: expressive,
        setExpressive: setExpressive,
        drapery: drapery,
        setDrapery: setDrapery,
        eyes: eyes,
        setEyes: setEyes,
        ears: ears,
        setEars: setEars,
        mouth: mouth,
        setMouth: setMouth,
        skinTones: skinTones,
        setSkinTones: setSkinTones,
        nose: nose,
        setNose: setNose,
        torso: torso,
        setTorso: setTorso,
        legs: legs,
        setLegs: setLegs,
        arms: arms,
        setArms: setArms,
        back: back,
        setBack: setBack,
        fancyDress: fancyDress,
        setFancyDress: setFancyDress,
        facialHair: facialHair,
        setFacialHair: setFacialHair,
        dramaticLighting: dramaticLighting,
        setDramaticLighting: setDramaticLighting,
        modelId: modelId,
        setModelId: setModelId,
        setQuickPoses: setQuickPoses,
        modelList: modelList,
        tutorList: tutorList,
        pageNumber: pageNumber,
        setPageNumber: setPageNumber,
        setVideoList: setVideoList,
        setWorking: setWorking,
        pageCount: pageCount,
        pageSize: pageSize,
        searchType: props.searchType,
        setOffset: setOffset,
        searchData: searchData,
        setImageList: setImageList,
        totalCount: totalCount,
        videoList: videoList,
        //tutorMap: tutorMap,
        working: working,
        searchImages: searchImages,
        imageList: imageList,
        canAccess: canAccess,
        visiblePhoto: currentPhoto,
        setVisiblePhoto: setCurrentPhoto,
        showLightBox: showLightBox,
        setShowLightBox: setShowLightBox,
        setSearchData: setSearchData,
        dateProcessed: dateProcessed,
        setDateProcessed: setDateProcessed

    }

   
    if (props.searchType == "video" && videoList)
    {
        return <SearchContext.Provider value={context}>
            <div key="allvideooptions">
                <div className="container-fluid">
                    <form onSubmit={(e)=>{e.preventDefault(); searchImages();}}>
                    <VideoOptions key="OptionsX" />
                    <div><div>
                        <SearchButton />
                    </div></div>
                    </form>
                </div>
                <Logon />
                <MyPagination key="topPagination" />
                {pinnedVideo && <VideoElement key='pinned-video' video={pinnedVideo} dateProcessed={dateProcessed} featured/>}

                <VideoList videos={videoList} dateProcessed={dateProcessed}/>
                <MyPagination key="bottomPagination" />

            </div></SearchContext.Provider>
    }

    else {
    return (
        <SearchContext.Provider value={context }>  <LightBox />
            <div>   
                <form onSubmit={(e)=>{e.preventDefault(); searchImages();}}>
            <ImageOptions/>
            <div><div>
                <SearchButton/>
                </div></div>
                </form>
            </div>
            <Logon/>
            <MyPagination key = "topPagination"/>
            <PhotoList/>
            <MyPagination key="bottomPagination" />
           
        </SearchContext.Provider>
        );
    }



}

function AdvancedSearch() {
    const { advancedSearch, setAdvancedSearch } = useContext(SearchContext);    
    return (<Grid.Col span={12} key="advanced-options"><label><input type='checkbox' checked={advancedSearch} onChange={() => setAdvancedSearch(!advancedSearch)} /> Show advanced search options</label></Grid.Col>)
}

function VideoOptions() {
    return (<div key="searchoptions">
        <Grid>
        <AdvancedSearch />
        <VideoCategoryType />
        <Materials />
        <VideoTypes />
        <Dates />
        <TutorName />
        <PoseType />
        <HumanOptions/>
        <Lighting />
        <QuickPoses/>
        <SearchText />
        </Grid>
        </div>);
}

function ImageOptions() {
    return <div key="imageoptions">
        <Grid>
        <AdvancedSearch />
        <ImageReferenceTypes />
        <PoseType />
        <TutorName/>
        <HumanOptions />
        <Lighting/>
        <SearchText/>
        </Grid>
        </div>
}

function HumanOptions() {
    const { categoryType, advancedSearch, poseType } = useContext(SearchContext);

    //console.log(categoryType?.value);

    if (categoryType?.value != 'Human') {
        return null;
    }

    let options = null;

    //console.log("Human options. " + poseType?.value);
    if (advancedSearch) {
        switch (poseType?.value) {
            case 'Portrait':
                options = <PortraitOptions/>;
                break;
            case 'Figure':
                options = <FigureOptions/>;
                break;
            case 'FaceCloseUp':
                options = <FaceCloseupOptions/>
                break;
            case 'BodyCloseUp':
                options = <BodyCloseupOptions/>;
                break;
        }

    }

    if (categoryType != null && categoryType.value == 'Human') {
        return <><ModelName />  <Age/>
        <Gender/>
        <SkinTone/>{options}</>
    }
    return null;
}

/*
interface SearchTextProps {
    onChange: (value: string) => void,
    value : string
}

function SearchText(props: SearchTextProps) {

    //const { freeText, setFreeText } = useContext(SearchContext);
    const [freeText, setFreeText] = useState(props.value);

    function update(value : string) {
        setFreeText(value);
        props.onChange(value);
    }


    return (

        <div key="SearchText" className="row"><div className="col-3">Description text</div><div className="col">
            <input key="SearchInput" type='text' value={freeText} onChange={(e) => update(e.target.value)} />
        </div>
        </div>

    );

}
*/


function SearchText() {

    const { freeText, setFreeText } = useContext(SearchContext);

    return SearchRow("With keywords", <Input key="SearchInput" type='text' value={freeText} onChange={(e) => setFreeText(e.target.value)} />);
}

function VideoCategoryType() {
    const options: OptionType[] = [
        { value: '', label: 'All' },
        { value: 'Human', label: 'Human' },
        { value: 'Animal', label: 'Animal' },
        { value: 'Landscape', label: 'Landscape' },
        { value: 'StillLife', label: 'Still life' },
        { value: 'Other', label: 'Other' }

    ];

    const { categoryType, setCategoryType} = useContext(SearchContext);

    return SearchRow("Video category", <StableSingleSelect key="videocategory_select" value={categoryType} options={options} isClearable onChange={(value : OptionType | undefined) => setCategoryType(value)} />);
}

function SearchRow(label: string, input: JSX.Element)
{
    return <><Grid.Col span={{ base: 12, sm: 4 }}>{label}</Grid.Col><Grid.Col span={{ base: 12, sm: 8 }}>{input}</Grid.Col></>
}


function Materials() {
    const options: OptionType[] = [
        { value: 'Oils', label: 'Oil paints' },
        { value: 'Acrylics', label: 'Acrylics' },
        { value: 'Charcoal', label: 'Charcoal' },
        { value: 'Chalk', label: 'Chalk' },
        { value: 'Watercolour', label: 'Watercolour' },
        { value: 'Gouache', label: 'Gouache' },
        { value: 'Pencil', label: 'Pencil' },
        { value: 'PenAndInk', label: 'Pen and ink' },
        { value: 'Pastels', label: 'Pastels' },
        { value: 'PanPastel', label: 'PanPastel' },


    ];

    function MaterialsChanged(
        value: MultiValue<OptionType>,
       // meta: ActionMeta<OptionType>
    ) {
        setMaterials(value);
    };

    const { materials, setMaterials} = useContext(SearchContext);

    return SearchRow("Materials", <StableMultiSelect value={materials} options={options} isClearable onChange={MaterialsChanged} />);
}

function VideoTypes() {
    const options: OptionType[] = [
        { value: 'RegularSession', label: 'Regular weekly session' },
        /*{ value: 'Demonstration', label: 'Demonstration' },
        { value: 'SkillsBased', label: 'Skills based video' },*/
        { value: 'SpecialSession', label: 'Special session' },
        { value: 'Trailer', label: 'Trailer' },
        { value: 'Short', label:'Short video'}
    ];

    function VideoTypesChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setVideoTypes(value);
    };

    const { videoTypes, setVideoTypes} = useContext(SearchContext);

    return SearchRow("Video type",<StableMultiSelect value={videoTypes} options={options} isClearable onChange={VideoTypesChanged} />);
}

function ModelName() {
    const { modelId, setModelId, advancedSearch } = useContext(SearchContext);
    const modelList = useContext(SearchContext).modelList;

    if (!advancedSearch && !modelId?.value)
     {
        return null;
    }

    return SearchRow("Model name",<StableSingleSelect value={modelId} options={modelList} isClearable onChange={(value : OptionType | undefined) => setModelId(value)} />);

}

function PortraitOptions() {
    return <>
        <HeadDirection/>      
        <HairLengths/>
        <FacialHair/>
        <Expressive/>
        <FancyDress/>
        </>;

}

function HeadDirection() {
    const options: OptionType[] = [
        { value: 'StraightOn', label: 'Straight on', metadata: HeadStraightOn },
        { value: 'SlightAngle', label: 'Slight angle', metadata: HeadSlightAngle },
        { value: 'ThreeQuarters', label: 'Three quarters', metadata: HeadThreeQuarters },
        { value: 'AlmostProfile', label: 'Almost profile', metadata: HeadAlmostProfile },
        { value: 'Profile', label: 'Profile', metadata: HeadProfile },
        { value: 'Up', label: 'Up', metadata: HeadUp },
        { value: 'Down', label: 'Down', metadata: HeadDown },
        { value: 'UpOneSide', label: 'Up and to one side', metadata: HeadUpRight },
        { value: 'DownOneSide', label: 'Down and to one side', metadata: HeadDownRight },
        { value: 'Unknown', label: 'Other' }

    ];

    function HeadDisplay(option: OptionType) {
        return (<div key={option.value} className="head-direction">{option.metadata == null ? "" : <img src={option.metadata} />}<span>{option.label}</span></div>);
    }

    const { headDirections, setHeadDirections } = useContext(SearchContext);

    function HeadDirectionChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setHeadDirections(value);
    };


    return SearchRow("Head direction",<StableMultiSelect value={headDirections} options={options} isClearable renderOption={renderOptionImage} onChange={HeadDirectionChanged} />);
}

function SkinTone() {
    const options: OptionType[] = [
        { value: 'White', label: 'White', metadata: '#FFD7C2' },
        { value: 'Olive', label: 'Olive', metadata: '#E0AE90' },
        { value: 'ModerateBrown', label: 'Moderate brown', metadata: '#C39060' },
        { value: 'DarkBrown', label: 'Dark brown', metadata: '#94471B' },
        { value: 'DarkestBrown', label: 'Darkest brown', metadata: '#492103' }
    ];

    function Display(option: OptionType) {

        const inside = <div className="inner-skin-tone" key={option.metadata}><div className="colour-block" style={{ backgroundColor: option.metadata }}></div><span>{option.label}</span></div>;
        return (<div key={option.value} className="skin-tone">{option.metadata == null ? "" : inside}</div>);
    }

    const { skinTones, setSkinTones } = useContext(SearchContext);

    function SkinToneChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setSkinTones(value);
    };

    return SearchRow("Skin tone", <StableMultiSelect value={skinTones} options={options} isClearable renderOption={renderOptionSkinTone} onChange={SkinToneChanged} />);
}

function Age() {
    const ageOptions: OptionType[] = [
        { value: 'Unknown', label: 'Unknown' },
        { value: 'UnderEighteen', label: 'Under 18' },
        { value: 'EighteenToThirty', label: '18 - 30' },
        { value: 'ThirtyToFifty', label: '30 - 50' },
        { value: 'FiftyToSeventy', label: '50 - 70' },
        { value: 'OverSeventy', label: '70+' },

    ];

    const { ages, setAges} = useContext(SearchContext);


    function AgeChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setAges(value);
    };

    return SearchRow("Age", <StableMultiSelect value={ages} options={ageOptions}  isClearable onChange={AgeChanged} />);

}

function FigurePoseType() {
    const options: OptionType[] = [
        { value: 'Standing', label: 'Standing' },
        { value: 'Seated', label: 'Seated' },
        { value: 'Lying', label: 'Lying down' },
        { value: 'Crouching', label: 'Crouching' },
        { value: 'Kneeling', label: 'Kneeling' },
        { value: 'Unknown', label: 'Other' },

    ];

    const { figurePoseTypes, setFigurePoseTypes} = useContext(SearchContext);

    function optionChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setFigurePoseTypes(value);
    };


    return SearchRow("Stance", <StableMultiSelect value={figurePoseTypes} options={options} isClearable onChange={optionChanged} />);

}

function Gender() {
    const options: OptionType[] = [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },

    ];

    function GenderChanged(
        value: MultiValue<OptionType>,
        //meta: ActionMeta<OptionType>
    ) {
        setGenders(value);
    };

    const { genders, setGenders} = useContext(SearchContext);

    return SearchRow("Gender", <StableMultiSelect value={genders} options={options} isClearable onChange={GenderChanged} />);

}

function BodyType() {
    const options: OptionType[] = [
        { value: 'Thin', label: 'Thinner than average' },
        { value: 'Average', label: 'Average' },
        { value: 'Large', label: 'Larger than average' },
        { value: 'Muscular', label: 'Muscular' }

    ];

    const { bodyTypes, setBodyTypes} = useContext(SearchContext);

    return SearchRow("Body type",<StableMultiSelect value={bodyTypes} options={options} isClearable onChange={(value : MultiValue<OptionType>) => setBodyTypes(value)} />);

}

function HairLengths() {
    const options: OptionType[] = [
        { value: 'ShavedOrBald', label: 'Shaved or bald' },
        { value: 'Short', label: 'Short' },
        { value: 'Medium', label: 'Medium' },
        { value: 'Long', label: 'Long' }

    ];

    const { hairLengths, setHairLengths} = useContext(SearchContext);

    return SearchRow("Hair length", <StableMultiSelect value={hairLengths} options={options} isClearable onChange={(value : MultiValue<OptionType>) => setHairLengths(value)} />);

}



function TutorName() {

    const { tutorId, setTutorId, advancedSearch, tutorList, searchType} = useContext(SearchContext);
    //const tutorList = useContext(SearchContext).tutorList;

    if (!advancedSearch) {
        return null;
    }

    if (searchType != 'video') {
        return null;
    }

    return SearchRow("Tutor", <StableSingleSelect value={tutorId} options={tutorList} isClearable onChange={(value : OptionType|undefined) => setTutorId(value)} />);

}

function Dates() {

    const { dateFrom, setDateFrom, dateTo, setDateTo, advancedSearch} = useContext(SearchContext);

    if (!advancedSearch) {
        return null;

    }


    return SearchRow("Between date", <>
            <DatePickerInput  leftSection={<FontAwesomeIcon icon={faCalendar}/>} value={dateFrom} onChange={(date) => setDateFrom(date as string | null)} clearable/>
            and
                <DatePickerInput leftSection={<FontAwesomeIcon icon={faCalendar}/>} value={dateTo} onChange={(date) => setDateTo(date as string | null)} clearable/>
                </>
    );

}

function PoseType() {
    const poseOptions: OptionType[] = [
        { value: 'Figure', label: 'Figure' },
        { value: 'Portrait', label: 'Portrait' },
        { value: 'FaceCloseUp', label: 'Close up of the face' },
        { value: 'BodyCloseUp', label: 'Close up of the body' }

    ];

    const { poseType, setPoseType, categoryType } = useContext(SearchContext);

    function PoseTypeChanged(
        value: OptionType | undefined | null
        //meta: ActionMeta<OptionType>
    ) {
        setPoseType(value);
    };


    if (categoryType?.value != 'Human') {
        return null;
    }

    return SearchRow("Pose type", <StableSingleSelect value={poseType} options={poseOptions} isClearable onChange={PoseTypeChanged} />);
}


function ImageReferenceTypes() {
    const options: OptionType[] = [
        {value: '', label: 'All'},
        { value: 'Human', label: 'Human' },
        { value: 'Animal', label: 'Animal' },
        { value: 'StillLife', label: 'Still Life' },
        { value: 'Landscape', label: 'Landscape' },

    ];

    const { categoryType, setCategoryType} = useContext(SearchContext);

    return SearchRow("Image category", <StableSingleSelect value={categoryType} options={options} isClearable onChange={(value : OptionType|undefined) => setCategoryType(value)} />);
}

function Nudity() {
    const { nudity, setNudity} = useContext(SearchContext);
    return <Grid.Col span={12}><TriState label="Include images with nudity?" value={nudity} onChanged={(x)=>setNudity(x)} /></Grid.Col>
}

function ColouredLighting() {
    const { colouredLighting, setColouredLighting} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Coloured lighting?" value={colouredLighting} onChanged={(value) => setColouredLighting(value)} /></Grid.Col>);
}

function ColouredBackground() {
    const { colouredBackground, setColouredBackground} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Coloured background?" value={colouredBackground} onChanged={(value) => setColouredBackground(value)} /></Grid.Col>);
}


function Expressive() {
    const { expressive, setExpressive} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="The model has a non-neutral expression?" value={expressive} onChanged={(value) => setExpressive(value)} /></Grid.Col>);
}

function Dynamic() {
    const { expressive, setExpressive} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Dynamic poses?" value={expressive} onChanged={(value) => setExpressive(value)} /></Grid.Col>);
}

function Drapery() {
    const { drapery, setDrapery} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Drapery?" value={drapery} onChanged={(value) => setDrapery(value)} /></Grid.Col>);
}

function Eyes() {
    const { eyes, setEyes} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of eyes?" value={eyes} onChanged={(value) => setEyes(value)} /></Grid.Col>);
}

function Ears() {
    const { ears, setEars } = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of ears?" value={ears} onChanged={(value) => setEars(value)} /></Grid.Col>);
}

function Mouth() {
    const { mouth, setMouth} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of mouths?" value={mouth} onChanged={(value) => setMouth(value)} /></Grid.Col>);
}

function Nose() {
    const { nose, setNose} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of noses?" value={nose} onChanged={(value) => setNose(value)} /></Grid.Col>);
}

function Torso() {
    const { torso, setTorso} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of torsos?" value={torso} onChanged={(value) => setTorso(value)} /></Grid.Col>);
}

function Legs() {
    const { legs, setLegs} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of legs / feet?" value={legs} onChanged={(value) => setLegs(value)} /></Grid.Col>);
}

function Back() {
    const { back, setBack} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Include photos where the back is visible" value={back} onChanged={(value) => setBack(value)} /></Grid.Col>);
}


function Arms() {
    const { arms, setArms} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Close-ups of arms / hands?" value={arms} onChanged={(value) => setArms(value)} /></Grid.Col>);
}

function Hands() {
    const { arms, setArms} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Include photos with hands" value={arms} onChanged={(value) => setArms(value)} /></Grid.Col>);
}

function FancyDress() {
    const { fancyDress, setFancyDress} = useContext(SearchContext);
    return <Grid.Col span={12}><TriState label="Fancy dress" value={fancyDress} onChanged={(value) => setFancyDress(value)} /></Grid.Col>
}

function FacialHair() {
    const { facialHair, setFacialHair} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Facial hair" value={facialHair} onChanged={(value) => setFacialHair(value)} /></Grid.Col>);
}

function DramaticLighting() {
    const { dramaticLighting, setDramaticLighting} = useContext(SearchContext);
    return (<Grid.Col span={12}><TriState label="Dramatic lighting" value={dramaticLighting} onChanged={(value) => setDramaticLighting(value)} /></Grid.Col>);
}


function FigureOptions() {
    return <>
        <FigurePoseType />
        <BodyType />
        <Nudity />
        <Dynamic />
        <Drapery />
        <FancyDress />
        <Back/>
    </>

}

function FaceCloseupOptions() {
    return <>
        <Eyes />
        <Ears />
        <Mouth />
        <Nose />
        <Hands/>
    </>
}

function BodyCloseupOptions() {
    return <>
        <Arms />
        <Hands/>
        <Legs />
        <Torso />
        <Back/>
    </>
}

function QuickPoses() {

    const { advancedSearch, categoryType, quickPoses, setQuickPoses} = useContext(SearchContext);

    if (!advancedSearch) {
        return null;
    }
    if (categoryType != null && categoryType?.value == 'Human') {
        return (<><Grid.Col span={12}><TriState label="Quick poses?" value={quickPoses} onChanged={(value) => setQuickPoses(value)} /></Grid.Col></>);
    }
    return null;
}

function Lighting() {
    const { advancedSearch, categoryType } = useContext(SearchContext);

    if (advancedSearch) {
        if (categoryType != null && (categoryType.value == 'Human' || categoryType.value == 'Animal')) {
            return <><ColouredBackground /><ColouredLighting /><DramaticLighting /></>
        }
    }

    return null;
}


function MyPagination() {

    const { setOffset, pageSize, totalCount, searchData, setWorking, searchType, setImageList, jwtToken, setVideoList, setPageNumber, pageCount, pageNumber, setSearchData} = useContext(SearchContext);
    const {userInformation, authToken} = useAuth();
        const { getToken } = useClerkAuth();

    async function handlePageClick(page: number) {
    
        const newOffset = totalCount == null ? 0 : (((page -1) * pageSize) % totalCount);

        const clerkToken = await getToken();
        
        setOffset(newOffset);
        
        if (searchData != null) {
            let newSearchData : SearchJson = {...searchData, Offset: newOffset}

            let json = encodeURIComponent(JSON.stringify(newSearchData, (_, v) => { if (v != null) return v; }));
            setSearchData(newSearchData);

            setWorking(true);

            let options = { 
                method: 'GET',
                cache: "no-store" as RequestCache,
                 headers: {... authToken?{'auth-token': authToken}:{}, ...getClerkHeader(clerkToken)} as HeadersInit

                };
    
            if (searchType == 'image') {
                const result: ImageSearchResult = await (await fetch(ajaxUrl + "/imagesearch?json=" + json, options)).json();
                setImageList(result.photos);
            }
            else {
                const result: VideoSearchResult = await (await fetch(ajaxUrl + "/videosearch?json=" + json, options)).json();
                setVideoList(result.videos);
            }
            setWorking(false);
        }

        setPageNumber(page);

    }

    if ((totalCount ?? 0) == 0) {
        return (<></>);
    }

    return (
        <div className={styles.paginationContainer}>
            <Pagination size="sm"
                onChange={handlePageClick}
                total={pageCount}
                value={pageNumber}
            />
        </div>);
        
    /*
    return (
        <div className={styles.paginationContainer}>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                forcePage={pageNumber}
                previousLabel="< previous"
                pageClassName={styles.pagination}
                previousClassName={styles.paginationPrevious}
                nextClassName={styles.paginationNext}
                activeClassName={styles.paginationActive}
                previousLinkClassName={styles.previousLink}
                nextLinkClassName={styles.nextLink}
                breakClassName={styles.paginationBreak}
                disabledClassName={styles.paginationDisabled}
                disabledLinkClassName={styles.paginationDisabledLink}
            />
        </div>
    );*/
}


function SearchButton() {
    const { working, searchImages} = useContext(SearchContext);
    if (working) {
        return (<Button disabled={working}>
            Searching ...
        </Button>);
    }
    else {
        return (<Button type="submit">
            Search
        </Button>);
    }
}

function Logon() {
    const { canAccess, imageList} = useContext(SearchContext);
    const {isSignedIn} = useClerkAuth();

    const loggedIn = isSignedIn;

    const router = useRouter();

    if (!canAccess && imageList != null && imageList.length != 0) {

        let logonUrl="/log-in?redirect_to=" + router.pathname;

        if (!loggedIn) {
            return (<div className="logon-notice">To access these images, please <Link href={logonUrl}>log on</Link> or <Link href="/raw-umber-subscription/" target="_blank">purchase a subscription</Link></div>)
        }
        else {
            return (<div className="logon-notice">These images are only available to gold subscribers. To upgrade, please <a href="mailto:info@rawumberstudios.com">contact us</a></div>)

        }
    }

    return (<></>);

}


interface LightboxModalProps {
    photo: Photo | null;
}


function LightboxModal(props: LightboxModalProps) {

    const { showLightBox, setShowLightBox, } = useContext(SearchContext);


    if (props.photo == null) {
        return <></>;
    }

    const handleClose =
        () => setShowLightBox(false);


    let file = props.photo.imageFile;
    let img = <div className={styles.lightboxImageBoundingBox}><img src={file} /></div>;

    let ar = 1;

    if (props.photo.width > 0 && props.photo.height > 0) {
        ar = props.photo.width / props.photo.height;
    }

    let copyright = <div className={styles.lightboxCopyright}>You may use this photograph for drawing, painting and sculpting from. You may share or sell your work. <strong>You may not, however, distribute the original images or use them for any other purposes.</strong> The copyright of the photograph remains with the photographer. </div>;
    let footer = <div className={styles.lightboxFooter}><Button onClick={handleClose}>Close</Button></div>
    let more = !!props.photo.modelId && <>, or view other photographs of this model <a href={`/image-search?model=${props.photo.modelId}`}>here</a></>
    let download = <div className={styles.lightboxDownload}>You can <a href={props.photo.extraLargeFile}>download a high resolution photo from here</a>{more}</div>
    let credit = props.photo.credit && <div className={styles.credit}>{props.photo.credit}</div>

    return (<Modal onClose={handleClose} fullScreen opened={showLightBox}><div className={styles.lightbox}>
        {img}{credit}{copyright}{download}{footer}</div>
        </Modal>);

}

function LightBox() {
    const { visiblePhoto, canAccess, showLightBox, setShowLightBox } = useContext(SearchContext);
    let copyright = <></>

    if (visiblePhoto?.isFree || canAccess) {
        return <LightboxModal photo={visiblePhoto} />
    }

    copyright = <div>To access this image, please <Link href="/log-in">log on</Link> or <Link href="/raw-umber-subscription/">purchase a subscription</Link></div>
    return (<Modal  opened={showLightBox} onClose={() => setShowLightBox(false)}>{copyright}</Modal>);
}


interface TileProps {
    photo: Photo,
}


function Tile(tprops: TileProps) {

    const { canAccess, showLightBox, setShowLightBox, setVisiblePhoto } = useContext(SearchContext);

    function showLightBoxForTile()
        {
   
        setVisiblePhoto(tprops.photo);
        setShowLightBox(true);
    }
    let ar = 1;

    if (tprops.photo.thumbnailWidth > 0 && tprops.photo.thumbnailHeight > 0) {
        {
            ar = tprops.photo.thumbnailWidth / tprops.photo.thumbnailHeight;
        }
    }

    let file = tprops.photo.thumbnailFile;

    let width = tprops.photo.thumbnailWidth;
    let height = tprops.photo.thumbnailHeight;

    /*if (tprops.photo.id==33743)
    {
        console.log(width);
        console.log(height);
    }*/
    //let rotation="0deg";
    let swap = false;

    switch (tprops.photo.orientation)
    {
        case 5:
            //rotation="90deg";
            swap = true;
            break;
        case 6:
           // rotation="90deg";
            swap = true;
            break;
        case 7:
            //rotation="-90deg";
            swap = true;
            break;
        case 8:
           // rotation="-90deg";
            swap = true;
            break;
    }

    /*if (swap)
    {
        let t = width;
        width = height;
        height = t;
    }*/
    if (!canAccess && !tprops.photo.isFree) {
        file = tprops.photo.pixelatedFile;
    }
    return (
        <AspectBox width= {width} height ={height}>
            <div className={styles.tile}>
                {/*eslint-disable-next-line @next/next/no-img-element*/}
                <img alt = "Photograph" src={file} width="100%" onClick={()=>showLightBoxForTile()} />
            </div>
            </AspectBox>
    );
};


function PhotoList() {
    const { imageList } = useContext(SearchContext);
    const breakpointColumnsObj = {
        default: 4,
        1100: 3,
        700: 2,
        500: 1
    };

    let breakPoints: number[] = [350, 500, 750];

    let masonry = <div></div>

    if (imageList != null && imageList.length != 0) {
        let breakPoints = {350:1, 500:3, 750:4};

        masonry = /*<ResponsiveMasonry columnsCountBreakPoints={breakPoints}>*/
            <Masonry>
            {imageList.map(x => (
                <Tile key={x.id} photo={x} />))}

        </Masonry>
       /* </ResponsiveMasonry>*/
    }

    return (masonry);
}

/*
function StableSelect({ ...props }) {
    return <Select {...props} instanceId={useId()} />;
  }
*/

function StableMultiSelect(
    props : {
    value: MultiValue<OptionType> | null | undefined,
    options: OptionType[],
    isClearable?: boolean,
    onChange : (value: MultiValue<OptionType>)=> void,
    renderOption?: MultiSelectProps['renderOption']
    }
    ) {
        function om(x: string [])
        {
            //this is because I used to use React.Select

            let o: OptionType [] = props.options;
            let f = o.filter(y=>(x.includes(y.value)));


            props.onChange(f);
        }

        let values = props.value?.map(x=>x.value);

        return (<MultiSelect
            data={props.options}
            searchable clearable
            onChange={om}
            value={values}
            renderOption={props.renderOption}
          />);

    }

function StableSingleSelect(
    props : {    
    value: OptionType | null | undefined,  
    options: MultiValue<OptionType> | undefined,
    isClearable?: boolean,
    onChange : (value: OptionType | undefined)=> void,
    itemComponent?: FC<any>
    }
    ) {

    function oc(x: string| null, ComboboxItem : ComboboxItem | null)
    {
        //this is because I used to use React.Select

        let o = props.options;

        if (o)
        {
               let f  = o.find(y=>(y.value == x));

               if (f)
               {
                props.onChange(f);
               }
               else
               {
                props.onChange(undefined);
               }

        }
    }

    //let v = props.options?.map(x=>x.value);

    let v  = props.options?.map<ComboboxItem>(x=>  ({label: x.label, value: x.value}));

    if (!v)
    {
        v = [];
    }

    return <Select data={v} value={props.value?.value} searchable clearable onChange={oc}/>

  }

  const renderOptionImage: MultiSelectProps['renderOption'] = ({ option }) => {
    const o = option as any;
    return (
      <Group wrap="nowrap">
        {o.metadata ? <Image alt={o.label} src={o.metadata} /> : null}
        <Text>{option.label}</Text>
      </Group>
    );
  };

  const renderOptionSkinTone: MultiSelectProps['renderOption'] = ({ option }) => {
    const o = option as any;
    const inside = o.metadata ? (
      <div className={styles.innerSkinTone}>
        <div className={styles.colourBlock} style={{ backgroundColor: o.metadata }}></div>
        <span>{option.label}</span>
      </div>
    ) : null;
    return (
      <Group wrap="nowrap">
        <div key={option.value} className={styles.skinTone}>{inside ?? ''}</div>
      </Group>
    );
  };

function getCategoryOptionType(name?: string) : OptionType | undefined
{
    if (!name)
    {
        return { value: 'Human', label: 'Human' };;
    }
    switch(name.toLowerCase())
    {
        case 'human':
            return { value: 'Human', label: 'Human' };
        case 'animal':
            return { value: 'Animal', label: 'Animal' };
        case 'stilllife':
            return { value: 'StillLife', label: 'Still Life' };
        case 'landscape':
            return { value: 'Landscape', label: 'Landscape' };
        case 'all':
            return { value: '', label: 'All' };

    }

    return { value: 'Human', label: 'Human' };            


}